import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "research-group-list-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "with-subhead" }, "Trees", -1)

import { computed } from 'vue'
import { usePageTitle } from '@/util/AppUtil'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { DataGroupType } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import ResearchGroupList from './ResearchGroupList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchGroupListPage',
  setup(__props) {

usePageTitle("Trees")


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ResearchGroupList, { "show-all": "" })
  ]))
}
}

})